export const NOTIFICATION_TABS = {
  all: 'all',
  documents: 'documents',
  organisationsAndBoards: 'organisationsAndBoards',
} as const;
